import { useState } from "react";
import dynamic from "next/dynamic";

import { useJuneSoEventTracking } from "@stadium/services/june-analytics/hooks/use-june-so-event-tracking";

import { getEventName } from "@stadium/helpers/analytics";

import { InternalButton } from "@sharedComponents/buttons";

import {
  CART,
  REQUEST_MOCKUP_BUTTON,
  REQUEST_MOCKUP_MODAL,
  REQUEST_MOCKUP_SERVICES,
} from "@constants/june-so";

import styles from "./main.module.scss";

const RequestMockupModal = dynamic(() => import("@components/modals/request-mockup"), {
  ssr: false,
});

const RequestMockupButton = ({
  lineItemsMapping,
  variantsMapping,
  storeName,
  storeNumber,
  pageName = CART,
}) => {
  const [isRequestMockupModalOpen, setIsRequestMockupModalOpen] = useState(false);
  const openRequestMockupModal = () => setIsRequestMockupModalOpen(true);
  const closeRequestMockupModal = () => setIsRequestMockupModalOpen(false);

  const { trackEvent } = useJuneSoEventTracking({ services: REQUEST_MOCKUP_SERVICES });

  const renderRequestMockupModal = () => {
    return (
      <RequestMockupModal
        closeModal={closeRequestMockupModal}
        lineItemsMapping={lineItemsMapping}
        variantsMapping={variantsMapping}
      />
    );
  };

  return (
    <>
      <InternalButton
        styleType="link"
        className={styles.requestMockUp}
        onClick={() => {
          trackEvent({
            eventName: getEventName({
              pageName,
              target: REQUEST_MOCKUP_MODAL,
              action: "clicked",
            }),
            eventProperties: {
              shop_name: storeName,
              shop_number: storeNumber,
            },
            componentName: REQUEST_MOCKUP_BUTTON,
          });
          openRequestMockupModal();
        }}
      >
        <span className={styles.requestMockUpText}>Request Mockups</span>
      </InternalButton>
      {isRequestMockupModalOpen && renderRequestMockupModal()}
    </>
  );
};

export default RequestMockupButton;
